import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { User } from "lucide-react";
import { useArtistUsp } from "@/api/hooks/useArtistUsp";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";

const ArtistPremiumHero = () => {
  const { uspText, hasUsp } = useArtistUsp();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Discover Tom Cruise – A Hollywood Icon!",
          text: `From "Top Gun" to "Mission: Impossible," Tom Cruise has defined action cinema for decades. A Hollywood legend with multiple accolades, he continues to thrill audiences worldwide. Check out his incredible journey here!`,
          url: `${window.location.origin}/tom-cruise`,
        });
      } else {
        alert(
          "Your browser does not support the Web Share API. Please use another browser."
        );
      }
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };
  return (
    <div className="relative max-md:pb-10 w-screen">

      <div className="flex items-center justify-around max-md:justify-between max-md:flex-col-reverse max-md:mt-20 max-md:gap-6 min-h-[75vh]">
        <div className="space-y-4 p-10 max-sm:p-0 rounded-3xl max-sm:px-4">
          <p className="text-xl max-sm:text-base flex items-center gap-4">
            <svg
              viewBox="0 0 60 60"
              fill="none"
              className="w-12 h-12 max-sm:w-6 max-sm:h-6"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M57.6276 34.0056C57.8571 32.5276 59.12 31.1042 59.12 29.56C59.12 28.0161 57.8574 26.5924 57.6276 25.1144C57.3865 23.5963 58.1441 21.8514 57.6793 20.4223C57.2087 18.9671 55.5671 18.0031 54.8811 16.6598C54.1894 15.3023 54.3675 13.4081 53.4748 12.1827C52.5822 10.9545 50.7226 10.5411 49.6493 9.4707C48.5789 8.39739 48.1655 6.53781 46.9373 5.64518C45.7119 4.75255 43.8177 4.9306 42.4602 4.23887C41.1172 3.55292 40.1529 1.91131 38.6977 1.44071C37.2686 0.975877 35.5237 1.73352 34.0056 1.49244C32.5276 1.26291 31.1042 0 29.56 0C28.0161 0 26.5924 1.26265 25.1145 1.49244C23.5963 1.73352 21.8514 0.975877 20.4223 1.44071C18.9671 1.91131 18.0031 3.55292 16.6598 4.23887C15.3023 4.9306 13.4081 4.75255 12.1827 5.64518C10.9545 6.53781 10.5411 8.39739 9.4707 9.4707C8.39739 10.5411 6.53781 10.9545 5.64518 12.1827C4.75255 13.4081 4.93061 15.3023 4.23888 16.6598C3.55293 18.0028 1.91132 18.9671 1.44071 20.4223C0.97588 21.8514 1.73353 23.5963 1.49244 25.1144C1.26292 26.5924 0 28.0158 0 29.56C0 31.1039 1.26266 32.5276 1.49244 34.0056C1.73353 35.5237 0.97588 37.2686 1.44071 38.6977C1.91132 40.1529 3.55293 41.1169 4.23888 42.4602C4.93061 43.8177 4.75255 45.7119 5.64518 46.9373C6.53781 48.1655 8.39739 48.5789 9.4707 49.6493C10.5411 50.7226 10.9545 52.5825 12.1827 53.4748C13.4081 54.3675 15.3023 54.1894 16.6598 54.8811C18.0028 55.5671 18.9671 57.2087 20.4223 57.6793C21.8514 58.1441 23.5963 57.3865 25.1145 57.6276C26.5924 57.8571 28.0158 59.12 29.56 59.12C31.1039 59.12 32.5276 57.8574 34.0056 57.6276C35.5237 57.3865 37.2686 58.1441 38.6977 57.6793C40.1529 57.2087 41.1169 55.5671 42.4602 54.8811C43.8177 54.1894 45.7119 54.3675 46.9373 53.4748C48.1655 52.5822 48.5789 50.7226 49.6493 49.6493C50.7226 48.5789 52.5825 48.1655 53.4748 46.9373C54.3675 45.7119 54.1894 43.8177 54.8811 42.4602C55.5671 41.1172 57.2087 40.1529 57.6793 38.6977C58.1441 37.2688 57.3865 35.5237 57.6276 34.0056ZM43.9639 9.49381L50.0396 14.7543L27.3301 40.9764L17.1764 30.8227L22.8588 25.1431L26.9084 29.1897L43.9639 9.49381ZM29.56 52.7345C16.7604 52.7345 6.38576 42.3599 6.38576 29.5603C6.38576 16.7607 16.7604 6.38602 29.56 6.38602C33.5118 6.38602 37.2342 7.37608 40.4885 9.12116L38.1696 11.8017C35.5665 10.539 32.6478 9.82996 29.56 9.82996C18.663 9.82996 9.82944 18.6636 9.82944 29.5605C9.82944 40.4575 18.663 49.2911 29.56 49.2911C40.457 49.2911 49.2906 40.4575 49.2906 29.5605C49.2906 26.8141 48.7281 24.1995 47.7149 21.8234L50.18 18.9734C51.813 22.1448 52.7342 25.7463 52.7342 29.5605C52.7345 42.3599 42.3599 52.7345 29.56 52.7345Z"
                fill="url(#paint0_linear_1067_11078)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1067_11078"
                  x1="7.61585"
                  y1="12.0803"
                  x2="51.9979"
                  y2="48.5839"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#0074D9" />
                  <stop offset="0.5" stopColor="#409EFF" />
                  <stop offset="1" stopColor="#409EFF" />
                </linearGradient>
              </defs>
            </svg>{" "}
            CELEBRITY APPEARANCE
          </p>
          <div className="flex flex-row justify-between items-center">
            <h1 className="text-5xl max-sm:text-2xl font-bold">{displayName}</h1>
            <div className=" z-40">
              <div className="flex flex-col justify-center items-center bg-white text-black p-2 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-6 cursor-pointer hover:scale-[1.2] transition-all duration-300"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          <p
            className={`max-w-lg max-sm:text-sm text-lg ${!hasUsp ? "opacity-80 italic" : ""}`}
          >
            {uspText}
          </p>

          <button className="bg-gradient-to-b from-[#EC2179] to-[#F16B2E] max-sm:text-base px-8 py-3 text-lg rounded-xl">
            SEE PRICE & BOOK
          </button>
        </div>
        <div className="w-[27rem] max-sm:w-[90%] shadow-2xl shadow-zinc-800 h-[600px] max-md:h-[500px] relative rounded-full max-md:rounded-[45%] overflow-hidden bg-[#2C2C2E] flex items-center justify-center">
          {profilePic ? (
            <OptimizedImage
              src={profilePic}
              alt={displayName}
              fill={true}
              loading="lazy"
              unoptimized={true}
              fetchPriority="high"
              className="object-cover object-top w-full h-full"
            />
          ) : (
            <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ArtistPremiumHero;
